import axios from "axios"
import React, { useEffect } from "react"
import { useParams } from "react-router"
import { useState } from "react"

const GameDetail = () => {

    let {Id} = useParams()

    let [dataGames, setDataGames] = useState(null)

    useEffect (() => {
        if(Id !== undefined){
            let getGamesById = async () => {
                let res = await axios.get(`https://backendexample.sanbersy.com/api/data-game/${Id}`)
            setDataGames({...res.data})
            }

        getGamesById()
        }
    }, [])

    
    
    return (
        <>
        {dataGames !== null && (
            <>
            <h1 style={{color: "white", fontSize: "45px", fontWeight: "bold", textAlign:"center", marginTop: "80px"}}>{dataGames.name}</h1>
            <br/>
            <img src={dataGames.image_url} style={{width: "50%", height: "300px", objectFit: "cover", display:"block", marginLeft:"auto", marginRight:"auto"}}/>
            <br/>
            <h1 style={{color: "white", fontSize: "25px", fontWeight: "bold", textAlign:"center"}} >Platform: {dataGames.platform}</h1>
            <h1 style={{color: "white", fontSize: "15px", fontWeight: "bold", textAlign:"center"}}> Release: {dataGames.release}</h1>
            <h1 style={{color: "white", fontSize: "15px", fontWeight: "bold", textAlign:"center"}} >Genre: {dataGames.genre}</h1>
            <h1  style={{color: "white", fontSize: "15px", fontWeight: "bold", textAlign:"center"}}>Game Role: {dataGames.singlePlayer ? 'Singleplayer' : null}  {dataGames.multiplayer ? 'Multiplayer' : null} </h1>
            
            </>
        )}
        </>
    )
}

export default GameDetail